import React from "react";
import PropTypes from "prop-types";

const colorClasses = {
  primary: "bg-peachYellow hover:bg-peachYellow/80 text-black",
  secondary: "bg-salmonPink hover:bg-salmonPink/80 text-black",
  accent: "bg-coralRed hover:bg-coralRed/80 text-white",
  dark: "bg-ashGray hover:bg-ashGray/80 text-white",
  red: "bg-errorRed hover:bg-errorRed/80 text-white",
  success: "bg-successGreen hover:bg-successGreen/80 text-white",
  black: "bg-black hover:bg-black/80 text-white",
};

const Button = ({
  text,
  onClick,
  type = "",
  color = "primary",
  disabled = false,
  "data-testid": dataTestId,
}) => {
  const colorClass =
    colorClasses[color] || "bg-peachYellow hover:bg-peachYellow/80 text-black";

  return (
    <button
      className={`${colorClass} w-1/4 min-w-32 p-2 rounded-md font-sans font-bold ${disabled ? "opacity-50" : "hover:cursor-pointer transition-all duration-300 ease-in-out"}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {text}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  color: PropTypes.string,
  disabled: PropTypes.bool,
  "data-testid": PropTypes.string,
};

export default Button;
